import { Component } from '@theme/component';

class ProductInformation extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    this.mediaEl = this.querySelector('.product-information__media');
    this.badgesEl = this.querySelector('.product-information__badges');
    const slideshowEl = this.querySelector('.product-information__media slideshow-component');

    if (!this.mediaEl || !slideshowEl) return;

    // Initialize based on current/initial slide
    const initial = slideshowEl.getAttribute('initial-slide') || 0;
    this.#setActive(initial);

    // Listen for slideshow selection changes on the component root
    this.addEventListener('slideshow:select', this.#handleSlideshowSelect, { signal });
  }

  #controller = new AbortController();

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  #handleSlideshowSelect = (e) => {
    if (!e || !e.detail || typeof e.detail.index === 'undefined') return;
    this.#setActive(e.detail.index);
  };

  #setActive(index) {
    if (this.mediaEl) {
      this.mediaEl.classList.toggle('product-information__media--active', Number(index) > 0);
    }
  }
}

if (!customElements.get('product-information-component')) {
  customElements.define('product-information-component', ProductInformation);
}
